<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main v-loading.fullscreen.lock="loading" style="overflow-x: hidden;">
      <el-form ref="sdbForm" label-width="150px">
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('field.shippingDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdbForm.sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdbForm.edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('field.keywordSearch')" >
                <el-select v-model="sdbForm.column" :placeholder="$t('msg.pleaseSelect')" style="width:90%" >
                  <template v-for = "item in tableData.columns">
                    <el-option v-if = "item.field !='fwVersionMore'" :key="item.title"  :label="item.title" :value="item.field"  ></el-option>
                </template>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-input v-model="sdbForm.keyword"></el-input>
            </el-col>
          </el-row>    
          <el-row>
            <el-col :span="24" style="text-align:center">              
              <el-button type="warning" @click="importFWversion"  size="small">{{$t('button.importFWversion')}}</el-button>   
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>         
              <input style="display:none" ref="fw-upload-input" id="fw-upload-input"   type="file" accept=".xlsx, .xls" @change="handleClick"> 
            </el-col>             
          </el-row>
        </el-form> 
      <el-row >  
        <Table :tableData="tableData" :linkAction="linkAction"/> 
      </el-row>

    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import Table from '../components/FuzzySearchTable'
import { apiFindShipping, apiUpdShippingFwVersion } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

import FileSaver from 'file-saver'
import XLSX from 'xlsx'


export default {
  name: 'shippingData',
  data() {    
    return {
      loading:false,   
      sdbForm:{
        sdate: '',
        edate: '',
        keyword: '',
        column: '',
      },   
      tableData: { 
        sel: null,
        columns: [
          { field:'customer', title: 'Customer', width: 250},
          { field:'deliveryNo', title: 'DELIVERY NO', width: 140 },
          { field:'serialNo', title: 'SERIAL NO', width: 150 },
          { field:'custSerialNo', title: 'CUST SERIAL NO', width: 160 },
          { field:'custNo', title: 'CUST NO', width: 135 },
          { field:'shippingDate', title: 'SHIPPING DATE', width: 180 },
          { field:'mesShippingDate', title: 'MES SHIPPING DATE', width: 190 },
          { field:'panelId', title: 'PANEL ID', width: 150},
          { field:'erpProductId', title: 'ERP PRODUCT ID', width: 165  },
          { field:'model', title: 'MODEL', width: 150 },
          { field:'modelName', title: 'MODEL NAME', width: 150  },
          { field:'invoiceNo', title:this.$i18n.t('field.invoiceNo'), width: 135 },
          { field:'orgCode', title: 'ORG CODE', width: 135 },
          { field:'cartonId', title: 'CARTON ID', width: 135  },
          { field:'grade', title: 'GRADE', width: 135 },
          { field:'sourceFab', title: 'SOURCE FAB', width: 135  },
          { field:'shipToName', title: 'SHIP TO NAME', width: 250  },
          { field:'warrantyDate', title: this.$i18n.t('field.warranty'), width: 135 },
          { field:'fwVersion', title: this.$i18n.t('field.fwVersion'), width: 135  },
         // { field:'fwVersionMore', title: this.$i18n.t('field.fwUpdHistory'), width: 135 },
          { field:'udi', title: 'UDI', width: 250 },
          { field:'installDate', title: this.$i18n.t('field.installedTime'), width: 150 },
          { field:'receivedDate', title: this.$i18n.t('field.receiveTime'), width: 180  }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'shippingDataTable',
        exportName: this.$i18n.t('menu.shippingData')
      },
    };
  },   
  components: {
    Breadcrumb,
    Table
  },
  mounted() {
    
  },
  methods: {
    readData(){     

      if(this.sdbForm.column == null || this.sdbForm.column == '' || this.sdbForm.keyword == null || this.sdbForm.keyword == ''){
        return this.$message.warning({message: 'Keyword Search '+this.$i18n.t('msg.fieldNotEmpty') , duration: 1000});
      }else{
        this.loading = true;
        this.tableData.data = [];
        this.tableData.originalTableData =  [];  
        this.tableData.currentPage=1;
        var sdate = '', edate = '';
        if(this.sdbForm.sdate != null && this.sdbForm.sdate != ''){        
          sdate = CommonUtil.dateFormatDate(this.sdbForm.sdate);
        }
        if(this.sdbForm.edate != null && this.sdbForm.edate != ''){        
          edate = CommonUtil.dateFormatDate(this.sdbForm.edate);
        }

        apiFindShipping({ headers: authHeader(), sdate:sdate, edate:edate, searchColumnName:this.sdbForm.column, keyWord:this.sdbForm.keyword}).then((response) => {    
          response.data.forEach((item, index) => { 
     
            if(item.warrantyDate != null && item.warrantyDate!= '' && item.warrantyDate.length > 10){
              item.warrantyDate = item.warrantyDate.substring(0,10);
            }         
            if(item.receivedDate != null && item.receivedDate!= '' && item.receivedDate.length > 10){
              item.receivedDate = CommonUtil.dateFormat(new Date(item.receivedDate));
            }  
            if(item.installDate != null && item.installDate!= '' && item.installDate.length > 10){
              item.installDate = item.installDate.substring(0,10);
            }  
          });
          this.tableData.data = response.data;
          this.tableData.originalTableData =  this.tableData.data;  
          this.tableData.currentPage=1;         

          this.loading = false;
        }).catch((err) => {
          console.log(err);
          this.loading = false;
        });
      }

      
    },
    linkAction(row, index){ 
        
    },
    search(){
      this.readData();
    },
    importFWversion(){
      this.$refs['fw-upload-input'].click()
    },
    handleClick(e){
      const files = e.target.files      
      const rawFile = files[0] ;
      if (!rawFile) return

      this.$refs[e.target.id].value = null;
      if (!this.beforeUpload) {
        if(e.target.id.indexOf('fw') > -1 ){
          this.readerFWData(rawFile)
          return
        }       
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        if(e.target.id.indexOf('fw') > -1 ){
          this.readerFWData(rawFile)
        }
      }
    },  
    readerFWData(rawFile) {
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          let alldata = [];
          for(var i=0; i< workbook.SheetNames.length;i++){
            const firstSheetName = workbook.SheetNames[i]
            const worksheet = workbook.Sheets[firstSheetName]
            const header = this.getHeaderRow(worksheet)
            var a = XLSX.utils.sheet_to_json(worksheet) ;
            const results = XLSX.utils.sheet_to_json(worksheet) 
          
            Array.prototype.push.apply(alldata, results);
          }
          
          for(var i = 0;i < alldata.length;i++){
            var obj = alldata[i];
            for(var key in obj){     
              var newKey = '';           
              if(key != null && key.toLowerCase().indexOf('serial')>-1){
                newKey = 'serialNo';
              }else if(key != null && key.toLowerCase().indexOf('version')>-1){
                newKey = 'fwVersion';
              }              
              if(newKey){
                obj[newKey] = obj[key];
                delete obj[key];
              }
            }
          }          
          apiUpdShippingFwVersion({ headers: authHeader(), sdbShippings:alldata}).then((response) => {               
            this.readData();
            this.loading = false;
          }).catch((err) => {
            console.log(err);
            this.loading = false;
          });

         
          resolve()
        }
        reader.readAsArrayBuffer(rawFile);
      })
    },   
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      for (C = range.s.c; C <= range.e.c; ++C) { 
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
  }
};
</script>
